<script>
import { useAlert } from 'dashboard/composables';
import {
  DuplicateContactException,
  ExceptionWithMessage,
} from 'shared/helpers/CustomErrors';

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
  },
  computed: {
    contactInfo() {
      if (this.phoneNumber && this.phoneNumber.includes('|||')) {
        const [name, phone] = this.phoneNumber.split('|||');
        return { name: name.trim(), phone: phone.trim() };
      }
      return { name: this.name, phone: this.phoneNumber };
    },
    displayPhone() {
      return this.contactInfo.phone;
    },
    formattedPhoneNumber() {
      return this.displayPhone.replace(/\s|-|[A-Za-z]/g, '');
    },
    rawPhoneNumber() {
      return this.displayPhone.replace(/\D/g, '');
    },
  },
  methods: {
    async addContact() {
      try {
        let contact = await this.filterContactByNumber(this.rawPhoneNumber);
        if (!contact) {
          contact = await this.$store.dispatch(
            'contacts/create',
            this.getContactObject()
          );
          useAlert(this.$t('CONTACT_FORM.SUCCESS_MESSAGE'));
        }
        this.openContactNewTab(contact.id);
      } catch (error) {
        if (error instanceof DuplicateContactException) {
          if (error.data.includes('phone_number')) {
            useAlert(this.$t('CONTACT_FORM.FORM.PHONE_NUMBER.DUPLICATE'));
          }
        } else if (error instanceof ExceptionWithMessage) {
          useAlert(error.data);
        } else {
          useAlert(this.$t('CONTACT_FORM.ERROR_MESSAGE'));
        }
      }
    },
    getContactObject() {
      const contactItem = {
        name: this.contactInfo.name || this.displayPhone,
        phone_number: `+${this.rawPhoneNumber}`,
      };
      return contactItem;
    },
    async filterContactByNumber(phoneNumber) {
      const query = {
        attribute_key: 'phone_number',
        filter_operator: 'equal_to',
        values: [phoneNumber],
        attribute_model: 'standard',
        custom_attribute_type: '',
      };

      const queryPayload = { payload: [query] };
      const contacts = await this.$store.dispatch('contacts/filter', {
        queryPayload,
        resetState: false,
      });
      return contacts.shift();
    },
    openContactNewTab(contactId) {
      const accountId = window.location.pathname.split('/')[3];
      const url = `/app/accounts/${accountId}/contacts/${contactId}`;
      window.open(url, '_blank');
    },
  },
};
</script>

<template>
  <div class="contact--group">
    <fluent-icon icon="call" class="file--icon" size="18" />
    <div class="meta">
      <p
        v-if="contactInfo.name && contactInfo.name !== displayPhone"
        class="overflow-hidden whitespace-nowrap text-ellipsis margin-bottom-0 font-semibold"
      >
        {{ contactInfo.name }}
      </p>
      <p
        class="overflow-hidden whitespace-nowrap text-ellipsis margin-bottom-0 text-xs text-subtle"
      >
        {{ displayPhone }}
      </p>
    </div>
    <div v-if="formattedPhoneNumber" class="link-wrap">
      <woot-button variant="clear" size="small" @click.prevent="addContact">
        {{ $t('CONVERSATION.SAVE_CONTACT') }}
      </woot-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.contact--group {
  align-items: center;
  display: flex;
  margin-top: var(--space-smaller);

  .meta {
    flex: 1;
    margin-left: var(--space-small);
  }

  .link-wrap {
    margin-left: var(--space-small);
  }
}
</style>
